import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["code", "submit", "status"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasCodeTarget || !this.hasSubmitTarget) return

    this.submitTarget.disabled = !this.codeTarget.value.trim()
  }

  statusTargetConnected(status) {
    if (!this.hasCodeTarget) return
    if (status.getAttribute("role") === "alert") return
    if (!status.textContent.trim()) return

    this.codeTarget.focus()
  }
}
